import React from 'react';
import { Typography } from '@material-ui/core';

import { Listing, ListingLegacy, SampleEstimatorListingTypes } from 'src/interfaces/idashboard';
import { COLOR_PRIMARY } from 'src/const';

const HeroTitleSection = ({
  data,
  isCompListing,
  // estimatorSampleListingData,
}: {
  data: any[] | Listing;
  isCompListing?: boolean;
  // estimatorSampleListingData?: SampleEstimatorListingTypes;
}) => {
  let dataToUse = data;

  // if (estimatorSampleListingData) {
  //   dataToUse = estimatorSampleListingData;
  // }

  return (
    <>
      {!isCompListing && (
        <Typography style={{ fontSize: 25, fontWeight: '500' }} variant="h5">
          {dataToUse['name']}
        </Typography>
      )}
      <Typography
        variant="h6"
        style={{ color: '#707070', fontWeight: 'normal', marginTop: '15px' }}
      >
        Entire home hosted by <span style={{ color: COLOR_PRIMARY }}>{dataToUse['host_name']}</span>
      </Typography>
      <Typography variant="body1" style={{ color: '#000', fontWeight: 'normal', marginTop: '5px' }}>
        <span style={{ color: COLOR_PRIMARY }}>{dataToUse['bedrooms']}</span> Bedrooms,{' '}
        <span style={{ color: COLOR_PRIMARY }}>{dataToUse['bathrooms']}</span> Bathroom,{' '}
        <span style={{ color: COLOR_PRIMARY }}>{dataToUse['accommodates']}</span> Guests,
      </Typography>
      <Typography
        variant="body1"
        style={{ color: '#707070', fontWeight: 'normal', marginTop: '5px' }}
      >
        {`★ ${dataToUse['review_scores_rating']} (${dataToUse['visible_review_count']} Reviews)`}
      </Typography>
    </>
  );
};

export default HeroTitleSection;
